import angular from 'angular';

export default function Title($interpolate, $state) {
  'ngInject';

  let _segments = [];

  function _getTitle(currentState) {
    const propertyReference =
      Object.hasOwnProperty.call(currentState.data, 'title') && currentState.data.title;

    if (angular.isUndefined(propertyReference) || propertyReference === false) {
      return false;
    }

    // use the $interpolate service to handle any bindings in the propertyReference string.
    const interpolationContext = angular.isDefined(currentState.locals)
      ? currentState.locals.globals
      : currentState;
    return $interpolate(propertyReference)(interpolationContext);
  }

  function _getState(state) {
    const title = _getTitle(state);
    if (title) {
      _segments.push(_getTitle(state));
    }

    if (state.parent && state.parent.name !== '') {
      _getState(state.parent);
    }
  }

  this.getTitle = function getTitle() {
    _segments = [];
    _getState($state.$current);

    if (_segments.length) {
      _segments.reverse();
      return ` - ${_segments.join(' - ')}`;
    }

    return '';
  };
}
